import { AutocompleteForm } from "modules/common/components";
import { Trustpilot } from "modules/storyblok/adapters/Trustpilot";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import {
  ChakraGrid as Grid,
  ChakraBox as Box,
  ChakraHeading as Heading,
  ChakraSimpleGrid as SimpleGrid,
  ChakraFlex as Flex,
} from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import type { AboveTheFoldAutocompleteProps } from "./AboveTheFoldAutocomplete.d";
import { PressImage } from "./PressImage";
import { textStyles } from "./AboveTheFoldAutocomplete.styles";

const MAX_GRID_WIDTH = "1344px";

export const AboveTheFoldAutocomplete = ({
  title,
  subtitle,
  srcMobile,
  srcDesktop,
  alt,
  buttonText,
  sbEditable,
}: SbEditableComponentProps<AboveTheFoldAutocompleteProps>) => (
  <Box px={{ base: 4, lg: 8 }} {...sbEditable}>
    <Grid mb={0} mx="auto" maxW={MAX_GRID_WIDTH}>
      <SimpleGrid
        templateColumns={{ base: "1fr", md: "45% 55%" }}
        pb={{ base: 8, md: 0 }}
        background="greyscale.200"
        borderRadius="2xl"
        overflow="hidden"
      >
        <Flex
          align="flex-start"
          direction="column"
          py={{ base: 8, lg: 20 }}
          mx={{ base: 4, md: 6, lg: "auto" }}
          maxWidth={{ base: "initial", lg: 96 }}
        >
          <Trustpilot />
          <Heading variant="h1" color="primary.900" my={2}>
            {title}
          </Heading>
          <RichtextAdapter content={subtitle} customStyles={textStyles} />
          <Box pt={{ base: 6, lg: 10 }} width="100%">
            <AutocompleteForm buttonText={buttonText} ctaVariant="primary" variant="narrow" />
          </Box>
        </Flex>
        {srcDesktop && <PressImage srcDesktop={srcDesktop} srcMobile={srcMobile} alt={alt} />}
      </SimpleGrid>
    </Grid>
  </Box>
);
